"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleProductSubmit = exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _reactRedux = require("react-redux");
var _CreateProductForm = _interopRequireDefault(require("./CreateProductForm"));
var _this = void 0;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var handleProductSubmit = function handleProductSubmit(data, formData) {
  var INDEX_POWER = 100;

  // specificities to be added
  var specificitiesToBeAdded = [];
  if (data.specificities && !_lodash.default.isEmpty(data.specificities)) {
    data.specificities.forEach(function (item, index) {
      specificitiesToBeAdded.push(item.specificity.id);
      if (item.choice) {
        if (item.type === 'date') {
          formData.append("product_specificities-".concat(index, "-specificity"), item.specificity.id);
          formData.append("product_specificities-".concat(index, "-date"), (0, _moment.default)(item.choice, 'DD-MM-YYYY').format('YYYY-MM-DD'));
        } else if (item.type === 'm_list') {
          formData.append("product_specificities-".concat(index, "-specificity"), item.specificity.id);
          formData.append("product_specificities-".concat(index, "-choices"), item.choice.join('|'));
        } else if (item.type === 'str') {
          formData.append("product_specificities-".concat(index, "-specificity"), item.specificity.id);
        } else {
          formData.append("product_specificities-".concat(index, "-specificity"), item.specificity.id);
          formData.append("product_specificities-".concat(index, "-choice"), item.choice);
        }
      }
    });
  }

  // specificities to be deleted
  _this.props.product.product_specificities.forEach(function (item, index) {
    var isFound = specificitiesToBeAdded.some(function (specificity) {
      return specificity === item.specificity.id;
    });
    if (!isFound && item.choice) {
      formData.append("del-store_specificities-".concat(index), 'on');
      formData.append("store_specificities-".concat(index, "-specificity"), item.specificity.id);
    }
  });
  delete data.specificities;
  if (data.options && !_lodash.default.isEmpty(data.options)) {
    var index = 0;
    data.options.forEach(function (item) {
      if (item.choice) {
        if (item.option.type === 'list') {
          var _iterator = _createForOfIteratorHelper(item.option.choice),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var choice = _step.value;
              formData.append("product_list_options-".concat(index, "-option"), item.option.id);
              formData.append("product_list_options-".concat(index, "-choice"), choice);
              index++;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else if (item.option.type === 'date') {
          var _iterator2 = _createForOfIteratorHelper(item.option.choice),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _choice = _step2.value;
              formData.append("product_date_options-".concat(index, "-option"), item.option.id);
              formData.append("product_date_options-".concat(index, "-date"), _choice);
              index++;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        } else if (item.option.type === 'boolean') {
          formData.append("product_bool_options-".concat(index, "-option"), item.option.id);
          formData.append("product_bool_options-".concat(index, "-choice"), item.option.choice);
          index++;
        } else {
          throw Error("".concat(item.option.type, " is not handled"));
        }
      }
    });
    delete data.options;
  }
  if (data['images-to-delete'] && data['images-to-delete'].length > 0) {
    data['images-to-delete'].forEach(function (img, index) {
      formData.append("images-".concat(index + INDEX_POWER * 999, "-inline_delete"), 'true');
      formData.append("images-".concat(index + INDEX_POWER * 999, "-id"), img);
    });
  }
  data.images.forEach(function (file, index) {
    if (file.file) {
      formData.append("images-".concat(index + INDEX_POWER * 999, "-name"), file.file);
      formData.append("images-".concat(index + INDEX_POWER * 999, "-type"), 'standard');
    } else {
      formData.append("images-".concat(index, "-id"), file.id);
      formData.append("images-".concat(index, "-type"), 'standard');
    }
  });
};
exports.handleProductSubmit = handleProductSubmit;
var _default = (0, _BaseInjectors.injectToBaseCreationDialog)(
/**
 * Wrap the component with the needed HOCs
 */
_lodash.default.flowRight((0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    pagination: state.ProductReducer.pagination,
    categories: state.categoryOfProductReducer ? state.categoryOfProductReducer.categories : null,
    options: state.optionOfProductReducer ? state.optionOfProductReducer.options : null,
    specificities: state.specificityOfProductReducer ? state.specificityOfProductReducer.specificities : null
  };
})),
// Options object
{
  // Pass the form
  createForm: _CreateProductForm.default,
  // Override componentDidMount to fetch categories and specificities
  componentDidMount: function componentDidMount() {
    this.props.dispatch({
      type: 'FETCH_CATEGORIES_OF_PRODUCT'
    });
    this.props.dispatch({
      type: 'FETCH_SPECIFICITIES_OF_PRODUCT'
    });
  },
  // Define the fields that are excluded in the handleSubmit
  excludedFields: ['images', 'specificities', 'options'],
  // Handle the excluded field inside the customHandleSubmit
  customHandleSubmit: handleProductSubmit
});
exports.default = _default;